import { useEffect } from "react";

/**
 * Lightweight client-side content protection.
 * Disables right-click context menu, common DevTools shortcuts and image drag.
 * Intended to discourage casual copying only — does NOT break forms or accessibility.
 */
export default function ContentProtection() {
  useEffect(() => {
    const blockKeys = (e) => {
      // F12
      if (e.key === "F12") {
        e.preventDefault();
        return false;
      }
      // Ctrl+U  (View Source)
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "u") {
        e.preventDefault();
        return false;
      }
      // Ctrl+Shift+I  (Inspector)
      // Ctrl+Shift+J  (Console)
      // Ctrl+Shift+C  (Element picker)
      if ((e.ctrlKey || e.metaKey) && e.shiftKey) {
        const k = e.key.toLowerCase();
        if (k === "i" || k === "j" || k === "c") {
          e.preventDefault();
          return false;
        }
      }
      return true;
    };

    const blockContext = (e) => {
      // Allow context menu inside form fields (inputs/textareas) to keep usability
      const tag = (e.target?.tagName || "").toLowerCase();
      const isFormField =
        tag === "input" ||
        tag === "textarea" ||
        tag === "select" ||
        e.target?.isContentEditable;
      if (isFormField) return true;
      e.preventDefault();
      return false;
    };

    const blockDrag = (e) => {
      const tag = (e.target?.tagName || "").toLowerCase();
      if (tag === "img") {
        e.preventDefault();
        return false;
      }
      return true;
    };

    window.addEventListener("keydown", blockKeys);
    window.addEventListener("contextmenu", blockContext);
    window.addEventListener("dragstart", blockDrag);

    // Also mark every <img> with draggable=false so native drag is suppressed
    const imgs = document.querySelectorAll("img");
    imgs.forEach((img) => img.setAttribute("draggable", "false"));

    return () => {
      window.removeEventListener("keydown", blockKeys);
      window.removeEventListener("contextmenu", blockContext);
      window.removeEventListener("dragstart", blockDrag);
    };
  }, []);

  return null;
}
